/**
 *
 * clip sagas
 *
 */

import {
    put, call, takeLatest, select,
} from 'redux-saga/effects';
import { LOAD_CLIP } from './clip-constants';
import { setClipData, clipLoadingError } from './clip-actions';
import { makeSelectClipEndpoint } from '../config/runtime-config-selectors';

import request from 'utils/request';

/**
 * Clip data request/response handler
 */
export function* getClipData(action) {
    const pattern = /^c-[0-9]*$/i;
    let contentId = action.id;
    const isHBId = pattern.test(contentId);

    if (isHBId) {
        contentId = contentId.split('c-')[1];
    }

    const urlTemplate = yield select(makeSelectClipEndpoint());

    const requestURL = urlTemplate ? urlTemplate.replace('{contentId}', contentId) : '';

    try {

        const data = yield call(request, requestURL);
        // TODO: figure out client vs server...
        // create an API library with a fetchClip method that takes a contentId as parameter
        // const data = yield call(Api.fetchClip, contentId)
        yield put(setClipData(data));

    } catch (error) {

        yield put(clipLoadingError(error));

    }

}

/**
 * Root saga manages watcher lifecycle
 */
export default function* clipData() {

    // Watches for LOAD_CLIP actions and calls getClipData when one comes in.
    // By using `takeLatest` only the result of the latest API call is applied.
    // It returns task descriptor (just like fork) so we can continue execution
    // It will be cancelled automatically on component unmount
    yield takeLatest(LOAD_CLIP, getClipData);

}
